import { createActionFactory } from '../../../common/redux';

//i will need to unify this
const { createAction } = createActionFactory('Common Entities => Winner => ');

const downloadWinnersExport = createAction('download winners export');
const sendWinnersExport = createAction('send winners export');

export default {
  downloadWinnersExport,
  sendWinnersExport,
};
